<template>
  <q-card flat bordered>
    <q-tabs
      v-model="tabPeriod"
      dense
      outside-arrows
      mobile-arrows
      :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
      active-color="white"
      :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
      :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
      align="justify"
      narrow-indicator
      @update:model-value="tabPeriodChange(tabPeriod)"
    >
      <q-tab name="daily" label="Daily" no-caps />
      <q-tab name="weekly" label="Weekly" no-caps />
      <q-tab name="monthly" label="Monthly" no-caps />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tabPeriod" animated>
      <q-tab-panel class="q-pa-none" :name="tabPeriod">
        <q-separator color="white" size="sm" />

        <q-tabs
          v-model="tabAction"
          dense
          outside-arrows
          mobile-arrows
          :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
          active-color="white"
          :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
          :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
          align="justify"
          narrow-indicator
          @update:model-value="tabActionChange(tabAction)"
        >
          <q-tab name="top-net-holding" label="Top Holding" no-caps />
          <q-tab name="top-net-released" label="Top Released" no-caps />
        </q-tabs>

        <q-separator />

        <q-tab-panels v-model="tabAction" animated>
          <q-tab-panel class="q-pa-none" :name="tabAction">
            <div class="flex flex-center q-ma-sm">
              <div
                v-for="sector in availableSectors[tabPeriod][tabAction]"
                :key="sector"
              >
                <q-btn
                  class="q-ma-sm-sm q-ma-xs-xs"
                  dense
                  :outline="activeSector === sector ? 'active-symbol' : ''"
                  :key="activeSector"
                  :color="$q.dark.mode ? 'grey-7' : 'primary'"
                  @click="
                    activeSector = sector;
                    loading = false;
                  "
                >
                  {{ sector }}
                </q-btn>
              </div>
            </div>

            <q-tabs
              v-model="tabDisplay"
              dense
              outside-arrows
              mobile-arrows
              :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
              active-color="white"
              :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
              :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
              align="justify"
              narrow-indicator
            >
              <q-tab name="tabular" label="Tabular" no-caps />
              <q-tab name="bar" label="Bar Graph" no-caps />
            </q-tabs>

            <q-tab-panels class="q-mt-xs" v-model="tabDisplay" animated>
              <q-tab-panel class="q-pa-xs" name="tabular">
                <div style="max-width: 900px; margin: auto">
                  <q-table
                    flat
                    bordered
                    :class="
                      $q.dark.mode
                        ? 'table-sticky-header-column-dark'
                        : 'table-sticky-header-column'
                    "
                    :rows="seriesData()"
                    :columns="
                      tabAction == 'top-net-holding'
                        ? columnsHolding
                        : columnsReleased
                    "
                    :loading="loading"
                    :filter="filterSymbol"
                    :filter-method="filterSectorTopStocks"
                    separator="cell"
                    :pagination="{
                      sortBy: 'amount',
                      descending: true,
                      rowsPerPage: 10,
                    }"
                  >
                    <template v-slot:top-left>
                      <q-input
                        borderless
                        dense
                        debounce="300"
                        v-model="filterSymbol"
                        placeholder="Filter Symbols"
                      >
                        <template v-slot:append>
                          <q-icon name="search" />
                        </template>
                      </q-input>
                    </template>
                    <template v-slot:body-cell-symbol="props">
                      <q-td :props="props">
                        <q-item
                          dense
                          clickable
                          :to="{
                            path: '/stock-profile',
                            query: {
                              symbol: props.value,
                            },
                          }"
                        >
                          <div class="col">
                            {{ props.value }}
                            <q-tooltip>{{
                              allStocks.find(
                                (stock) => stock.symbol == props.value
                              )?.name
                            }}</q-tooltip>
                          </div>
                        </q-item>
                      </q-td>
                    </template>
                    <template v-slot:body-cell-buyer="props">
                      <q-td :props="props">
                        <q-item
                          class="row justify-end"
                          dense
                          clickable
                          :to="{
                            path: '/brokers-analytics-pro',
                            query: {
                              brokerID: props.value,
                              transaction: 'Purchase',
                            },
                          }"
                        >
                          {{ props.value }}
                        </q-item>
                      </q-td>
                    </template>
                    <template v-slot:body-cell-seller="props">
                      <q-td :props="props">
                        <q-item
                          class="row justify-end"
                          dense
                          clickable
                          :to="{
                            path: '/brokers-analytics-pro',
                            query: {
                              brokerID: props.value,
                              transaction: 'Selling',
                            },
                          }"
                        >
                          {{ props.value }}
                        </q-item>
                      </q-td>
                    </template>
                  </q-table>
                </div>
              </q-tab-panel>

              <q-tab-panel class="q-pa-none" name="bar">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <p class="text-subtitle2 q-mx-sm">
                      Amount of top
                      {{ activeSector }} stocks
                      {{ tabAction.split("-").slice(-1)[0] }}
                      {{ tabPeriod }}
                    </p>
                    <div id="chart-overall" class="q-my-md"></div>
                  </div>
                  <div class="col-12 col-md-6">
                    <p class="text-subtitle2 q-mx-sm">
                      Brokerwise
                      {{ tabAction.split("-").slice(-1)[0] }}
                      amount of
                      {{ selectedSymbol }}
                    </p>
                    <div id="chart-by-symbol" class="q-my-md"></div>
                  </div>
                </div>
              </q-tab-panel>
            </q-tab-panels>
          </q-tab-panel>
        </q-tab-panels>
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useQuasar } from "quasar";
import useData from "src/use/data";
import { useStore } from "vuex";

import ApexChart from "apexcharts";

const $q = useQuasar();
const { brokerTopHolding, brokerTopRelease } = useData();
const $store = useStore();
const allStocks = ref($store.state.core.allStocks);

const selectedSymbol = ref("");

const brokerTopHoldingDaily = ref(null);
const brokerTopHoldingWeekly = ref(null);
const brokerTopHoldingMonthly = ref(null);

const brokerTopReleasedDaily = ref(null);
const brokerTopReleasedWeekly = ref(null);
const brokerTopReleasedMonthly = ref(null);

let elOverallChart;
let elSymbolChart;

const chartInstance = ref(null);
const chartSymbolInstance = ref(null);

const tabPeriod = ref("daily");
const tabAction = ref("top-net-holding");
const tabDisplay = ref("tabular");

const availableSectors = computed(() => {
  return {
    daily: {
      "top-net-holding": Object.keys(brokerTopHoldingDaily.value || {}),
      "top-net-released": Object.keys(brokerTopReleasedDaily.value || {}),
    },
    weekly: {
      "top-net-holding": Object.keys(brokerTopHoldingWeekly.value || {}),
      "top-net-released": Object.keys(brokerTopReleasedWeekly.value || {}),
    },
    monthly: {
      "top-net-holding": Object.keys(brokerTopHoldingMonthly.value || {}),
      "top-net-released": Object.keys(brokerTopReleasedMonthly.value || {}),
    },
  };
});

const activeSector = ref("");

function seriesData() {
  return tabPeriod.value == "daily" &&
    tabAction.value == "top-net-holding" &&
    brokerTopHoldingDaily.value
    ? brokerTopHoldingDaily.value[activeSector.value]
    : tabPeriod.value == "daily" &&
      tabAction.value == "top-net-released" &&
      brokerTopReleasedDaily.value
    ? brokerTopReleasedDaily.value[activeSector.value]
    : tabPeriod.value == "weekly" &&
      tabAction.value == "top-net-holding" &&
      brokerTopHoldingWeekly.value
    ? brokerTopHoldingWeekly.value[activeSector.value]
    : tabPeriod.value == "weekly" &&
      tabAction.value == "top-net-released" &&
      brokerTopReleasedWeekly.value
    ? brokerTopReleasedWeekly.value[activeSector.value]
    : tabPeriod.value == "monthly" &&
      tabAction.value == "top-net-holding" &&
      brokerTopHoldingMonthly.value
    ? brokerTopHoldingMonthly.value[activeSector.value]
    : tabPeriod.value == "monthly" &&
      tabAction.value == "top-net-released" &&
      brokerTopReleasedMonthly.value
    ? brokerTopReleasedMonthly.value[activeSector.value]
    : [];
}

function getSeries(brokerData) {
  return [
    {
      data: brokerData?.slice(0, 10).map((bd) => {
        return {
          x: bd.symbol,
          y: bd.amount,
        };
      }),
    },
  ];
}

function getStockSeries(brokerData, symbol) {
  let bysymbol = brokerData.reduce((acc, curr) => {
    let symbol = curr.symbol;
    let broker = curr.buyer ?? curr.seller;
    if (!acc[symbol]) {
      acc[symbol] = [];
    }
    acc[symbol].push(curr);
    return acc;
  }, {});

  return [
    {
      data: bysymbol[symbol].slice(0, 10).map((bd) => {
        return {
          x: bd.buyer ?? bd.seller,
          y: bd.amount,
        };
      }),
    },
  ];
}

const chartOptions = {
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
    toolbar: {
      show: false,
    },

    events: {
      dataPointSelection: function (event, chartContext, config) {
        const dp = config.dataPointIndex;

        selectedSymbol.value = chartContext.data.twoDSeriesX[dp];

        elSymbolChart = document.querySelector("#chart-by-symbol");
        if (elSymbolChart) {
          elSymbolChart.innerHTML = null;
          chartSymbolInstance.value = new ApexChart(elSymbolChart, {
            ...chartOptions,
            series: getStockSeries(seriesData(), selectedSymbol.value),
          });
          chartSymbolInstance.value.render();
        }
      },
    },
  },

  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"],
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    theme: "dark",
  },
  // tooltip: {
  //   y: {
  //     formatter: function (val) {
  //       return val;
  //     },
  //   },
  // },
  yaxis: {
    title: {
      // text: "Amount",
    },
  },
  xaxis: {
    title: {
      // text: "Stock Symbol",
    },
  },
};

const columnsHolding = [
  {
    name: "symbol",
    label: "Symbol",
    field: "symbol",
    sortable: true,
    align: "left",
  },
  {
    name: "buyer",
    label: "Buyer",
    field: "buyer",
    sortable: true,
    align: "right",
  },

  {
    name: "quantity",
    label: "Quantity (Lakh)",
    field: "quantity",
    sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
    sortable: true,
    format: (val, row) => {
      return parseFloat(val / 100000).toFixed(2);
    },
    align: "right",
  },
  {
    name: "amount",
    label: "Amount (Cr.)",
    field: "amount",
    sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
    sortable: true,
    format: (val, row) => {
      return parseFloat(val / 10000000).toFixed(2);
    },
    align: "right",
  },
  {
    name: "rate",
    label: "Rate",
    field: "rate",
    sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
    sortable: true,
    format: (val, row) => {
      return parseFloat(val).toFixed(2);
    },
    align: "right",
  },
];
const columnsReleased = [
  {
    name: "symbol",
    label: "Symbol",
    field: "symbol",
    sortable: true,
    align: "left",
  },

  {
    name: "seller",
    label: "Seller",
    field: "seller",
    sortable: true,
    align: "right",
  },
  {
    name: "quantity",
    label: "Quantity (Lakh)",
    field: "quantity",
    sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
    sortable: true,
    format: (val, row) => {
      return parseFloat(val / 100000).toFixed(2);
    },
    align: "right",
  },
  {
    name: "amount",
    label: "Amount (Cr.)",
    field: "amount",
    sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
    sortable: true,
    format: (val, row) => {
      return parseFloat(val / 10000000).toFixed(2);
    },
    align: "right",
  },
  {
    name: "rate",
    label: "Rate",
    field: "rate",
    sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
    sortable: true,
    format: (val, row) => {
      return parseFloat(val).toFixed(2);
    },
    align: "right",
  },
];

const loading = ref(true);
const filterSymbol = ref("");
const filterSectorTopStocks = (rows, terms, cols, getCellValue) => {
  return rows.filter((row) => {
    return row.symbol.toLowerCase().includes(filterSymbol.value.toLowerCase());
  });
};

const tabPeriodChange = (tabPeriod) => {
  activeSector.value = availableSectors.value[tabPeriod][tabAction.value][0];
  loading.value = false;
};
const tabActionChange = (tabAction) => {
  activeSector.value = availableSectors.value[tabPeriod.value][tabAction][0];
  loading.value = false;
};

//------  BROKERLIST TOP  HOLDING ------//

brokerTopHolding(0)
  .then((res) => {
    brokerTopHoldingDaily.value = res.data
      .filter((i) => i.sector !== undefined)
      .reduce((acc, cur) => {
        acc[cur.sector] = acc[cur.sector] || [];
        acc[cur.sector].push(cur);
        return acc;
      }, {});
    tabPeriodChange("daily");
    tabActionChange("top-net-holding");
  })
  .then(() => {
    brokerTopHolding(5).then((res) => {
      brokerTopHoldingWeekly.value = res.data
        .filter((i) => i.sector !== undefined)
        .reduce((acc, cur) => {
          acc[cur.sector] = acc[cur.sector] || [];
          acc[cur.sector].push(cur);
          return acc;
        }, {});
    });
  })
  .then(() => {
    brokerTopHolding(20).then((res) => {
      brokerTopHoldingMonthly.value = res.data
        .filter((i) => i.sector !== undefined)
        .reduce((acc, cur) => {
          acc[cur.sector] = acc[cur.sector] || [];
          acc[cur.sector].push(cur);
          return acc;
        }, {});
    });
  })
  .then(() => {
    //------  BROKERLIST TOP  RELEASE ------//
    brokerTopRelease(0).then((res) => {
      brokerTopReleasedDaily.value = res.data
        .filter((i) => i.sector !== undefined)
        .reduce((acc, cur) => {
          acc[cur.sector] = acc[cur.sector] || [];
          acc[cur.sector].push(cur);
          return acc;
        }, {});
    });
  })
  .then(() => {
    brokerTopRelease(5).then((res) => {
      brokerTopReleasedWeekly.value = res.data
        .filter((i) => i.sector !== undefined)
        .reduce((acc, cur) => {
          acc[cur.sector] = acc[cur.sector] || [];
          acc[cur.sector].push(cur);
          return acc;
        }, {});
    });
  })
  .then(() => {
    brokerTopRelease(20).then((res) => {
      brokerTopReleasedMonthly.value = res.data
        .filter((i) => i.sector !== undefined)
        .reduce((acc, cur) => {
          acc[cur.sector] = acc[cur.sector] || [];
          acc[cur.sector].push(cur);
          return acc;
        }, {});
    });
  });

watch(
  [tabPeriod, tabAction, tabDisplay, activeSector],
  ([a, b, c, d], [e, f, g, h]) => {
    setTimeout(() => {
      elOverallChart = document.querySelector("#chart-overall");
      if (elOverallChart) {
        elOverallChart.innerHTML = null;
        chartInstance.value = new ApexChart(elOverallChart, {
          ...chartOptions,
          series: getSeries(seriesData()),
        });
        chartInstance.value.render();
      }

      elSymbolChart = document.querySelector("#chart-by-symbol");
      if (elSymbolChart) {
        elSymbolChart.innerHTML = null;
        selectedSymbol.value = seriesData()[0].symbol;
        chartSymbolInstance.value = new ApexChart(elSymbolChart, {
          ...chartOptions,
          series: getStockSeries(seriesData(), selectedSymbol.value),
        });
        chartSymbolInstance.value.render();
      }
    }, 100);
  }
);
</script>
